import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const BasicButton = props => {
  const {
    btnWidth = 200,
    btnHeight = 40,
    btnHref,
    btnText = 'Button Text',
    btnFontSize = '0.8571rem',
    btnFontWeight = 400,
    btnArrow = true,
    btnBg = 'transparent',
    btnTextColor = '#27282d',
    btnHoverBg = '#f40',
    btnHoverTextColor = '#fff',
    disabled = false,
    btnTextAlign = 'left',
    controlFunc,
    style,
    ...anchorProps
  } = props;

  useEffect(() => {
    setHover(false);
  }, [disabled]);

  const [hover, setHover] = useState(false);

  const hoverOn = () => {
    setHover(true);
  };

  const hoverOff = () => {
    setHover(false);
  };

  let inputProps;

  const btnStyles = {
    backgroundColor: hover ? btnHoverBg : btnBg,
    color: hover ? btnHoverTextColor : btnTextColor,
    fontSize: btnFontSize,
    minHeight: btnHeight + 'px',
    ...(btnWidth !== 'auto' && {minWidth: btnWidth + 'px'}),
    fontWeight: btnFontWeight,
    ...style,
  };

  const disabledStyles = {
    backgroundColor: '#ebebeb',
    borderColor: '#ebebeb',
    cursor: 'not-allowed',
    fontSize: btnFontSize,
    minHeight: btnHeight + 'px',
    ...(btnWidth !== 'auto' && {minWidth: btnWidth + 'px'}),
    fontWeight: btnFontWeight,
  };

  if (btnHref) {
    inputProps = {
      href: btnHref,
    };
  } else {
    inputProps = {
      onClick: controlFunc,
    };
  }

  return (
    <>
      {!!disabled ? (
        <a
          className="basic-button basic-button--disabled"
          style={disabledStyles}
        >
          <div className="basic-button__text">{btnText}</div>
          {btnArrow && <span className="basic-button__icon-arrow" />}
        </a>
      ) : (
        <a
          {...inputProps}
          {...anchorProps}
          style={btnStyles}
          className="basic-button"
          onMouseEnter={hoverOn}
          onMouseLeave={hoverOff}
          onMouseOver={hoverOn}
          onMouseOut={hoverOff}
          onMouseUp={hoverOn}
          onMouseDown={hoverOff}
          onFocus={hoverOn}
          onBlur={hoverOff}
        >
          <div className="basic-button__text" style={{ textAlign: btnTextAlign }}>{btnText}</div>
          {btnArrow && <span className="basic-button__icon-arrow" />}
        </a>
      )}
    </>
  );
};

BasicButton.propTypes = {
  disabled: PropTypes.bool,
  btnHeight: PropTypes.number,
  btnHref: PropTypes.string,
  controlFunc: PropTypes.func,
  btnText: PropTypes.string.isRequired,
  btnTextAlign: PropTypes.oneOf(['left', 'center', 'right']),
  btnFontSize: PropTypes.string,
  btnFontWeight: PropTypes.number,
  btnBg: PropTypes.string,
  btnTextColor: PropTypes.string,
  btnHoverBg: PropTypes.string,
  btnHoverTextColor: PropTypes.string,
  btnArrow: PropTypes.bool,
};

export default BasicButton;
